module.exports = __webpack_public_path__ + "tan_img.da26980a.png";